/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegionCityWithZipCodeResponse } from '../../models/region-city-with-zip-code-response';

export interface GetAllZipCodes$Params {
}

export function getAllZipCodes(http: HttpClient, rootUrl: string, params?: GetAllZipCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RegionCityWithZipCodeResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllZipCodes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RegionCityWithZipCodeResponse>>;
    })
  );
}

getAllZipCodes.PATH = '/delivery/methods/zip-codes';
